import { useContext } from "react";
import { LINK_STYLES } from "./plenary-download";
import { StepActions } from "./step-actions";
import { StepperContext } from "./stepper";

export function DownloadTerms() {
  const { step, nextStep, cancel } = useContext(StepperContext);

  const active = !step;

  return (
    <>
      <span>
        Mit dem Download des Videos erklären Sie sich mit den&nbsp;
        <a
          className={LINK_STYLES}
          rel="noopener noreferrer"
          target="_blank"
          tabIndex={step === 0 ? 0 : -1}
          href="https://www.bundesrat.de/DE/service/mediathek/mediathek-nutzungsbedingungen.html"
        >
          Nutzungsbedingungen
        </a>
        &nbsp;des Bundesrates einverstanden.
      </span>

      <StepActions
        cancelLabel="Abbrechen"
        cancelDisabled={!active}
        handleCancel={cancel}
        nextLabel="Akzeptieren"
        nextDisabled={!active}
        handleNext={nextStep}
      />
    </>
  );
}
